import { render, staticRenderFns } from "./forward-settlement.vue?vue&type=template&id=a02fc8e8&scoped=true"
import script from "./forward-settlement.vue?vue&type=script&lang=js"
export * from "./forward-settlement.vue?vue&type=script&lang=js"
import style0 from "./forward-settlement.vue?vue&type=style&index=0&id=a02fc8e8&prod&lang=scss&scoped=true"
import style1 from "./forward-settlement.vue?vue&type=style&index=1&id=a02fc8e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02fc8e8",
  null
  
)

export default component.exports